import { CheckedState } from "@radix-ui/react-checkbox";
import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Checkbox, RadioButtons, TimeRangePicker } from "@swivl-mono/ui";
import _ from "lodash";
import TimezoneSelect, { type ITimezone } from "react-timezone-select";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

function minutesToTime(inputMinutes: number) {
  var period;
  var minutes: any = inputMinutes % 60;
  if (minutes === 0) {
    minutes = "00";
  }
  var hours: any = (inputMinutes - minutes) / 60;
  if (hours > 12) {
    hours -= 12;
    period = "PM";
  } else if (hours === 12) {
    period = "PM";
  } else if (hours === 0) {
    hours = "12";
    period = "AM";
  } else if (hours === 24) {
    period = "AM";
  } else {
    period = "AM";
  }

  return hours + ":" + minutes + " " + period;
}

const DayOfWeek = {
  Type: "dateAndTime",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: DayOfWeek.Type,
      showTyping: false,
      delay: 0,
      logicType: "day",
      daysSelected: {
        Monday: { selected: true, goto: null },
        Tuesday: { selected: true, goto: null },
        Wednesday: { selected: true, goto: null },
        Thursday: { selected: true, goto: null },
        Friday: { selected: true, goto: null },
        Saturday: { selected: false, goto: null },
        Sunday: { selected: false, goto: null }
      },
      time: { start: 540, end: 1020 },
      withinTimeGoto: null,
      elseGoto: null,
      timezone: "America/Los_Angeles"
    };

    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    var title = "";
    var tabs: any = [];
    if (node.logicType === "day") {
      title = "Day of Week";
      var numberOfDaysSelected = 0;
      for (var key in node.daysSelected) {
        if (node.daysSelected.hasOwnProperty(key) && node.daysSelected[key].selected) {
          numberOfDaysSelected++;
          tabs.push({
            id: "daysSelected_" + key,
            source: "daysSelected_" + key + "_goto",
            target: node.daysSelected[key].goto,
            title: key
          });
        }
      }
      if (numberOfDaysSelected < 7) {
        tabs.push({
          id: "elseGoto",
          source: "elseGoto",
          target: node.elseGoto,
          title: "ELSE"
        });
      }
    }
    if (node.logicType === "time") {
      title = "Time of Day";

      tabs = [
        {
          id: "withinTimeGoto",
          source: "withinTimeGoto",
          target: node.withinTimeGoto,
          title: minutesToTime(node.time.start) + " - " + minutesToTime(node.time.end)
        },
        {
          id: "elseGoto",
          source: "elseGoto",
          target: node.elseGoto,
          title: "ELSE"
        }
      ];
    }
    return TabNodeLayoutData({
      node: node,
      title: title,
      baseWidth: 150,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);

      this.onLogicTypeChange = this.onLogicTypeChange.bind(this);
      this.onCheckboxChange = this.onCheckboxChange.bind(this);
      this.onTimeUpdate = this.onTimeUpdate.bind(this);
      this.onTimezoneUpdate = this.onTimezoneUpdate.bind(this);
      this.state = { selectedOption: this.props.node.validationType };
    }

    onLogicTypeChange(event: any) {
      this.onChangeUpdateAndRedraw(event);
    }

    onCheckboxChange(checked: CheckedState, name: `daysSelected.${string}.selected`) {
      this.onChangeUpdateAndRedraw({ target: { name: name, value: checked } });
    }

    onTimeUpdate(time: any) {
      let node = JSON.parse(JSON.stringify(this.props.node));
      _.set(node, "time.start", time.start);
      _.set(node, "time.end", time.end);

      this.props.updateNode(node, this.props.node);
    }
    onTimezoneUpdate(timezone: any) {
      let node = JSON.parse(JSON.stringify(this.props.node));
      _.set(node, "timezone", timezone);
      this.props.updateNode(node, this.props.node, true);
    }

    render() {
      const options = [
        { id: "time", value: "time", label: "Time of Day" },
        { id: "day", value: "day", label: "Day of Week" }
      ];
      var content;
      if (this.props.node.logicType == "day") {
        content = (
          <div className="dayOfWeek">
            Day of Week:
            <br />
            <Checkbox
              label="Monday"
              name="daysSelected.Monday.selected"
              checked={this.props.node.daysSelected.Monday.selected}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "daysSelected.Monday.selected")}
            />
            <br />
            <Checkbox
              label="Tuesday"
              name="daysSelected.Tuesday.selected"
              checked={this.props.node.daysSelected.Tuesday.selected}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "daysSelected.Tuesday.selected")}
            />
            <br />
            <Checkbox
              label="Wednesday"
              name="daysSelected.Wednesday.selected"
              checked={this.props.node.daysSelected.Wednesday.selected}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "daysSelected.Wednesday.selected")}
            />
            <br />
            <Checkbox
              label="Thursday"
              name="daysSelected.Thursday.selected"
              checked={this.props.node.daysSelected.Thursday.selected}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "daysSelected.Thursday.selected")}
            />
            <br />
            <Checkbox
              label="Friday"
              name="daysSelected.Friday.selected"
              checked={this.props.node.daysSelected.Friday.selected}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "daysSelected.Friday.selected")}
            />
            <br />
            <Checkbox
              label="Saturday"
              name="daysSelected.Saturday.selected"
              checked={this.props.node.daysSelected.Saturday.selected}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "daysSelected.Saturday.selected")}
            />
            <br />
            <Checkbox
              label="Sunday"
              name="daysSelected.Sunday.selected"
              checked={this.props.node.daysSelected.Sunday.selected}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "daysSelected.Sunday.selected")}
            />
            <br />
          </div>
        );
      }

      if (this.props.node.logicType == "time") {
        content = (
          <div className="timeOfDay">
            Time of day:
            <br />
            <TimeRangePicker start={this.props.node.time.start} end={this.props.node.time.end} name="time" onChange={this.onChangeUpdateAndRedraw} />
          </div>
        );
      }
      return (
        <div>
          <div className="panel dayOfWeek_panel" style={{ paddingBottom: "300px" }}>
            <InspectorNodeHeader title="Date &amp; Time" />
            <div className="panelRow">
              Type:
              <RadioButtons options={options} name="logicType" value={this.props.node.logicType} onChange={this.onLogicTypeChange} />
              {content}
              <br />
              Timezone: <br />
              <div className="timeZone" style={{ width: "100%" }}>
                <TimezoneSelect value={this.props.node.timezone} onChange={this.onTimezoneUpdate} />

                {/* <TimezonePicker
                  value={this.props.node.timezone}
                  onChange={this.onTimezoneUpdate}
                  style={{ width: "100%" }}
                  inputProps={{
                    placeholder: 'Select Timezone...',
                    name: 'timezone',
                  }}
                /> */}
              </div>
            </div>
          </div>
          <div className="carouselPadding"></div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};

export default DayOfWeek;
